// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton_backButton__1r4OB","arrowBack":"BackButton_arrowBack__1CyQD"};